import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from '@angular/router';

import { AggregatorFeatureFlag } from '@env/aggregator/aggregator.interface';

import { AggregatorFeatureFlagService } from '../../services/aggregator-feature-flag.service';
import { ClaimsService } from '@core/authentication/claims.service';

@Injectable({
  providedIn: 'root'
})
export class AggregatorFeatureFlagGuard implements CanActivate {
  constructor(
    private readonly featureFlagService: AggregatorFeatureFlagService,
    private readonly claimsService: ClaimsService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const featureFlag = route.data
      .aggregatorFeatureFlag as AggregatorFeatureFlag;
    if (featureFlag) {
      return this.featureFlagService.isEnabled(featureFlag);
    }

    return false;
  }
}
